import { render, staticRenderFns } from "./UploadFeatures.vue?vue&type=template&id=6ee6a644&scoped=true"
import script from "./UploadFeatures.vue?vue&type=script&lang=js"
export * from "./UploadFeatures.vue?vue&type=script&lang=js"
import style0 from "./UploadFeatures.vue?vue&type=style&index=0&id=6ee6a644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee6a644",
  null
  
)

export default component.exports